export default "__VITE_ASSET__Bc16sTzP__"